import React, { useEffect, useState } from "react";
import CompanySlotDays from "./CompanySlotDays";
import CompanySpecialSlot from "./CompanySpecialSlot";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import StatusComp from "../../../components/StatusComp";
import SelectBox from "../../../components/SelectBox";
import { siteDetails } from "../../redux/api/dummyJson";
import { BASE_URL, URL } from "../../../Services/Constant";
import { get, post } from "../../../Services/ApiHandler";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";

const days_arr = [
  { day: "Monday", type: 1, start_time: "", end_time: "", toggle: false },
  { day: "Tuesday", type: 2, start_time: "", end_time: "", toggle: false },
  { day: "Wednesday", type: 3, start_time: "", end_time: "", toggle: false },
  { day: "Thursday", type: 4, start_time: "", end_time: "", toggle: false },
  { day: "Friday", type: 5, start_time: "", end_time: "", toggle: false },
  { day: "Saturday", type: 6, start_time: "", end_time: "", toggle: false },
  { day: "Sunday", type: 7, start_time: "", end_time: "", toggle: false },
];

const CompanySlotMain = ({ type }) => {
  const [activeTab, setActiveTab] = useState("week");
  const [days, setDays] = useState([...days_arr]);
  const [dates, setDates] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);

  const handleClose = () => {
    setShowPopup(false);
  };

  // useEffect(() => {
  //   const slotDays = JSON.parse(localStorage.getItem("slotDays"));
  //   if (slotDays) {
  //     setActiveTab(slotDays);
  //   } else {
  //     setActiveTab("week");
  //     localStorage.setItem("slotDays", JSON.stringify("week"));
  //   }
  // }, []);

  const handleTab = (days) => {
    setActiveTab(days);
    // setOption(null);
    // setDates([]);
    localStorage.setItem("slotDays", JSON.stringify(days));
  };

  const navigate = useNavigate();

  const location = useLocation();

  // const type = location?.state?.type;
  const createdAt = moment().format("DD-MM-YYYY");

  const [option, setOption] = useState(null);
  const [siteList, setSiteList] = useState([]);
  const [fileUpload, setFileUpload] = useState("");

  const getSiteList = () => {
    get(URL.ACTIVE_SITE + "?knf_type=1")
      .then((res) => {
        if (res?.sites?.length > 0) {
          setSiteList(res?.sites);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getDayList = (knf_company_site_id) => {
    if (!type) {
      setOption(knf_company_site_id);
    }
    if (knf_company_site_id?.value) {
      let formdata = new FormData();
      formdata.append("knf_company_site_id", knf_company_site_id?.value);
      post(URL.DAY_LIST, formdata)
        .then((res) => {
          if (res?.data?.length > 0) {
            let temp = [...days_arr];
            let data = [...res?.data];
            let day_type = [1, 2, 3, 4, 5, 6, 7];
            data?.map((item, ind) => {
              if (day_type?.includes(item?.type)) {
                let indexToReplace = day_type.findIndex(
                  (i) => i === item?.type
                );
                temp[indexToReplace] = {
                  ...temp[indexToReplace],
                  toggle: item?.start_time && item?.end_time ? true : false,
                  start_time: item?.start_time
                    ? moment(item?.start_time, "hh:mm:ss").format("HH:mm")
                    : "",
                  end_time: item?.end_time
                    ? moment(item?.end_time, "hh:mm:ss").format("HH:mm")
                    : "",
                };
              }
            });
            setDays(temp);
          } else {
            setDays([]);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      setDays(days_arr);
    }
  };

  const getDateList = (knf_company_site_id, ind) => {
    setOption(knf_company_site_id);
    if (knf_company_site_id?.value) {
      let formdata = new FormData();
      formdata.append("knf_company_site_id", knf_company_site_id?.value);
      post(URL.DATE_LIST, formdata)
        .then((res) => {
          if (res?.data?.length > 0) {
            let temp = [];
            let data = [...res?.data];
            data?.map((item, ind) => {
              let obj = {
                ...item,
                toggle: item?.start_time && item?.end_time ? true : false,
                date: item?.for_date,
                for_date: moment(item?.for_date).format("DD-MM-YYYY"),
                start_time: item?.start_time
                  ? moment(item?.start_time, "hh:mm:ss").format("HH:mm")
                  : "",
                end_time: item?.end_time
                  ? moment(item?.end_time, "hh:mm:ss").format("HH:mm")
                  : "",
              };
              temp.push(obj);
            });
            setDates(temp);
            if (ind) {
              setSelectedDate(temp?.[ind]?.id);
            } else {
              setSelectedDate(temp?.[0]?.id);
            }
          } else {
            setDates([]);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      setDates([]);
    }
  };

  useEffect(() => {
    if (type) {
      getDayList({ value: location?.state?.data?.id });
      getDateList({ value: location?.state?.data?.id });
    } else {
      getSiteList();
    }
  }, []);

  const handleSubmit = (ind) => {
    let temp = [...days];
    let data = temp[ind];
    let formdata = new FormData();
    // formdata.append("id", knf_company_site_id?.value);
    if (option?.value) {
      formdata.append("knf_company_site_id", option?.value);
      formdata.append("type", data?.type);
      formdata.append("start_time", data?.start_time);
      formdata.append("end_time", data?.end_time);
      post(URL.SPECIAL_DAY_STORE, formdata)
        .then((res) => {
          if (res?.status == "success") {
            toast.success(res?.message);
            getDayList(option);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      toast.error("Please select Site");
    }
  };

  const handleDateSubmit = (ind) => {
    let temp = [...dates];
    let data = temp[ind];
    let formdata = new FormData();
    // formdata.append("id", knf_company_site_id?.value);
    if (option?.value) {
      formdata.append("knf_company_site_id", option?.value);
      formdata.append("date", data?.date);
      formdata.append("start_time", data?.start_time);
      formdata.append("end_time", data?.end_time);
      post(URL.SPECIAL_DATE_STORE, formdata)
        .then((res) => {
          if (res?.status == "success") {
            toast.success(res?.message);
            getDateList(option, ind);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      toast.error("Please select Site");
    }
  };

  const sampleExcelDownload = () => {
    if (option?.value) {
      // get(URL.SAMPLE_DATE_EXCEL_DOWNLOAD)
      //   .then((res) => {})
      //   .catch((err) => {
      //     console.log("err", err);
      //   });

      try {
        const link = document.createElement("a");
        link.href = BASE_URL + URL.SAMPLE_DATE_EXCEL_DOWNLOAD;
        link.setAttribute("download", "");
        link.setAttribute("target", "_blank");
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        console.log("error", error);
      }
    } else {
      toast.error("Please Select Site");
    }
  };

  const specialDateImport = () => {
    if (option?.value) {
      if (fileUpload?.name) {
        let formdata = new FormData();
        formdata.append("file", fileUpload);
        formdata.append("knf_company_site_id", option?.value);
        post(URL.SPECIAL_DATE_IMPORT, formdata)
          .then((res) => {
            if (res?.status == "success") {
              getDateList(option, 0);
              setFileUpload("");
              handleClose();
              toast.success(res?.success);
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      } else {
        toast.error("Upload a File");
      }
    } else {
      toast.error("Please Select Site");
    }
  };

  const handleTabFun = (knf_company_site_id) => {
    getDayList(knf_company_site_id);
    getDateList(knf_company_site_id);

    // if (activeTab === "week") {
    //   getDayList(knf_company_site_id);
    // } else {
    //   getDateList(knf_company_site_id);
    // }
  };

  return (
    <div className="dashRightView">
      <StatusComp name={"Slot days"} hide={true} />
      {!type && (
        <div className="d-flex align-items-end justify-content-end flex-column w-100">
          <p
            className="f1 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-2"
            style={{ marginRight: "160px" }}
          >
            Select Site
          </p>
          <SelectBox
            arrayData={siteList}
            selectedOption={option}
            setSelectedOption={handleTabFun}
            style={true}
            width={"250px"}
          />
        </div>
      )}

      <div className="tab-header d-flex gap-3 mb-3 ms-4">
        <button
          className={`tab-btn ${activeTab === "week" ? "active" : ""}`}
          onClick={() => handleTab("week")}
        >
          Week days
        </button>
        <button
          className={`tab-btn ${activeTab === "special" ? "active" : ""}`}
          onClick={() => handleTab("special")}
        >
          Special Holidays
        </button>
      </div>

      <div>
        {activeTab == "week" && (
          <CompanySlotDays
            days={days}
            setDays={setDays}
            handleSubmit={handleSubmit}
            option={option}
            type={type}
          />
        )}
        {activeTab == "special" && (
          <CompanySpecialSlot
            setShowPopup={setShowPopup}
            dates={dates}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            setDates={setDates}
            handleDateSubmit={handleDateSubmit}
            option={option}
            type={type}
          />
        )}
      </div>

      <Modal show={showPopup} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title> Import Excel</Modal.Title>
        </Modal.Header>
        <div className="p-3">
          <button
            className="text-start cust-btn rounded-3 bg-primar p-2 d-grid  text-white"
            onClick={() => sampleExcelDownload()}
          >
            Sample Download
          </button>
          <div className="mt-4">
            <h6>Upload Excel</h6>
            <input
              type="file"
              className="form-control w-100 mt-3"
              accept=".xlsx, .xls, .csv"
              onChange={(e) => {
                setFileUpload(e.target.files[0]);
              }}
            />
          </div>
        </div>
        <div className="d-flex justify-content-end pt-2 mb-3 mx-5">
          <button
            className="cust-btn bg-primar text-white rounded-3 p-2 d-grid m-3"
            onClick={handleClose}
          >
            Cancel
          </button>
          <button
            className="cust-btn bg-primar text-white rounded-3 p-2 d-grid m-3"
            onClick={() => specialDateImport()}
          >
            Submit
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default CompanySlotMain;
